// extracted by mini-css-extract-plugin
module.exports = {"container":"DevicesSection_container___AZ1E","card":"DevicesSection_card___kB0S","buttonClassName":"DevicesSection_buttonClassName__X_IKP"};